module.exports = __webpack_public_path__ + "c0bed862f1ec953d28e102a4fa518e6a.png";


//////////////////
// WEBPACK FOOTER
// ./static/icons/easy_go_logo.png
// module id = 3185
// module chunks = 0